import { version } from '../../package.json';

export const APP = {
    version,
    url: import.meta.env.VITE_ICLASS_APP_URL,
    env: import.meta.env.VITE_APP_ENV,
    sentry: {
        enable: import.meta.env.VITE_SENTRY_ENABLE === 'true' ? true : false,
        dns: import.meta.env.VITE_SENTRY_DNS
    }
}